import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import { GSDevTools } from 'gsap/GSDevTools';
// gsap.registerPlugin(GSDevTools);

export default function gpsData() {
  const mm = gsap.matchMedia();

  // Desktop
  mm.add('(min-width: 960px)', () => {
    ScrollTrigger.create({
      trigger: '#abw_section_6',
      pin: '#abw_section_6',
      start: 'top top',
      end: '+=200%',
      scrub: true,
      anticipatePin: 1,
      onRefresh: (self) => self.progress && self.animation.progress(1)
    });

    gsap.set('#abw_section_6 .col_6:last-of-type', {
      opacity: 1,
      xPercent: '101',
      scaleX: '0.9'
    });

    gsap.set('#liane9', {
      drawSVG: 0
    });

    gsap.set('#abw_gps_data', {
      opacity: 0,
      yPercent: '30'
    });

    //gsap.set('#euro_coin *', { fill: 'transparent' });

    gsap
      .timeline({
        defaults: {
          opacity: 1,
          yPercent: '0',

          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: '#abw_section_6',
          pin: false,
          scrub: true,
          onRefresh: (self) => self.progress && self.animation.progress(1),
          start: 'top 40%',
          end: '+=300%'
          // markers: true,
          // id: 'Section 6'
        }
      })
      .fromTo(
        '#liane9',
        { drawSVG: 0 },
        { drawSVG: '100%', ease: 'none', duration: 6 },
        0
      )
      .to('#abw_gps_data', {}, 1)
      .to('#abw_section_6 .col_6:last-of-type', { xPercent: '10' }, 2.5);
  });

  // Mobile
  mm.add('(max-width: 959px)', () => {
    gsap.set('#liane9', {
      drawSVG: 0
    });
    gsap.set('#abw_gps_data', {
      opacity: 0,
      xPercent: 30
    });

    //gsap.set('#euro_coin *', { fill: 'transparent' });
    gsap
      .timeline({
        defaults: {
          ease: 'none'
        },
        scrollTrigger: {
          trigger: '#abw_section_6',
          // pin: '#abw_section_6',
          scrub: true,
          start: 'top 50%',
          end: 'bottom bottom'
        }
      })
      .fromTo(
        '#liane9',
        { drawSVG: 0 },
        { drawSVG: '100%', ease: 'none', duration: 4 },
        0
      )
      .to('#abw_gps_data', { opacity: 1, xPercent: 0, duration: 1 }, 1);
  });
  // GSDevTools.create({ animation: tl });
}
